import { render, staticRenderFns } from "./no-result-btn.vue?vue&type=template&id=6c0d639d&scoped=true&"
import script from "./no-result-btn.vue?vue&type=script&lang=js&"
export * from "./no-result-btn.vue?vue&type=script&lang=js&"
import style0 from "./no-result-btn.vue?vue&type=style&index=0&id=6c0d639d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0d639d",
  null
  
)

export default component.exports